import React from 'react';
import Modal from '../../../../shared/modal';
import QuestionsTable from '../tables/QuestionsTable';


interface IUnansweredQuestionsModal {
    openModal: boolean;
    handleCloseModal: () => void;
}

const UnansweredQuestionsModal = ({
    openModal,
    handleCloseModal,
}: IUnansweredQuestionsModal) => {

    const onCloseModal = () => {
        handleCloseModal();
    }

    return (
        <Modal
            open={openModal}
            onClose={onCloseModal}
            contentContainerStyle={'!rounded-xl min-w-[95%] md:min-w-[70%] lg:min-w-[60%]'}>
            <div className={'p-2 max-w-[98vw] min-w-[95%] md:min-w-[70%] lg:min-w-[60%] min-h-[500px] '}>
                <div className='flex flex-row justify-between items-center'>
                    <p className='mb-2 font-semibold text-sm dark:text-primary-dark'>Sofia - Unanswered questions </p>
                </div>
                <div>
                    <QuestionsTable
                        onCloseModal={onCloseModal}
                    />
                </div>
            </div>
        </Modal >
    )
}
export default UnansweredQuestionsModal;